import * as React from "react";
import { MwapApp } from "@lululemon/mwa-common";
import Cookie from "js-cookie";
import "intersection-observer"; // polyfill for intersection observer in old browsers
import "requestidlecallback"; // shim for requestIdleCallback in old browsers
import "@lululemon/mwa-polyfills";
import memoize from "lodash/memoize";
require("./../../../node_modules/@module-federation/nextjs-mf/src/include-defaults.js");
var backupGet = Cookie.get;
var backupSet = Cookie.set;
var refetchCookie = Date.now();
if (process.browser) {
    var getCookie = memoize(function(stamp) {
        return backupGet();
    });
    var cachedCooke = function(arg) {
        var now = Date.now();
        if (refetchCookie + 100 < now) {
            refetchCookie = now;
        }
        var cookieMap = getCookie(refetchCookie);
        if (!arg) {
            return cookieMap;
        }
        return cookieMap[arg];
    };
    Cookie.get = function(arg) {
        var force = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        // only use memoization on these for now
        if (force) {
            refetchCookie = 0;
        }
        var getter = arg === "lll_oidc_token" || arg === "membership" || arg === "UsrLocale" || arg === "sl" || arg === "pdpAlsoAvailableIn" || arg === "pdpInseamV2" ? cachedCooke : backupGet;
        return getter(arg);
    };
    Cookie.set = function(name, value, attributes) {
        // resets it to 0 so the next get will refresh memory
        refetchCookie = 0;
        backupSet(name, value, attributes);
    };
}
if (!process.browser) {
    // reduces log noise from react SSR warning about layoutEffect
    React.useLayoutEffect = React.useEffect;
}
export default MwapApp;
